import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {NullStorage, RealStorage} from '@specials/localstorage';

import {FrontendError} from '@/services/ErrorService/FrontendError';
import {LoggerService} from '@/services/LoggerService/LoggerService';

import {CacheData, CacheStorageAbstract} from './CacheStorageAbstract';

export class CacheLocalStorage extends CacheStorageAbstract {
  constructor(
    private readonly localStorageService: RealStorage | NullStorage,
    private readonly loggerService: LoggerService,
  ) {
    super();
  }

  public getCacheByKey = <T>(key: string): CacheData<T> | null => {
    const cacheString = this.localStorageService.getItem(key);

    if (!cacheString) {
      return null;
    }

    try {
      return JSON.parse(cacheString) as CacheData<T>;
    } catch (error: unknown) {
      const cacheError = FrontendError.createCacheServiceDataParseError(error as Error, key, cacheString);
      this.loggerService.logCacheServiceDataParseError(cacheError);

      return null;
    }
  };

  public setCacheByKey = <T>(key: string, data: CacheData<T>): void => {
    this.localStorageService.setItem(key, JSON.stringify(data));
  };

  public clearCacheByKey = (key: string): void => {
    this.localStorageService.removeItem(key);
  };
}

injected(CacheLocalStorage, DI_TOKENS.localStorageService, DI_TOKENS.loggerService);
